import { makeStyles } from '@material-ui/core/styles'

import { inboxCardShape, resourceCardShape } from './cardShapes'

export default makeStyles((theme) => ({
  skeletonContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  skeletonLine: {
    height: theme.spacing(2.5)
  },
  // The skeleton stands in for real rows, so it borrows their geometry rather
  // than restating it — see cardShapes.
  inboxCard: inboxCardShape(theme),
  resourceCard: resourceCardShape(theme)
}))
